import React from 'react'
import { Text } from '@theneatcompany/nui'
import { FormattedMessage } from 'react-intl'
import Image from 'next/image'
import PropTypes from 'prop-types'

import Spinner from '@/components/common/Spinner'
import NeatLogoSvg from '@/assets/svg/NeatLogo.svg'

import styles from './LoadingScreen.module.scss'

const LoadingScreen = ({ outsideApp = false }) => (
  <div className={styles.body}>
    <div className={styles.content}>
      <Image className={styles.logo} src={NeatLogoSvg} height={53} width={203} alt="Neat Logo" priority />
      <Text element="h1" size="small" type="display" typeStyle="bold" className={styles.description}>
        {outsideApp ? 'Preparing your account...' : <FormattedMessage id="preparingAccount" />}
      </Text>
      <Spinner className={styles.spinner} />
    </div>
  </div>
)

LoadingScreen.propTypes = {
  outsideApp: PropTypes.bool,
}

export default LoadingScreen
